module.exports = __webpack_public_path__ + "static/media/newsThumbnailSample2.10ea9253.jpg";